export default {
  auth_url: "https://bls-api.veetal.app/auth",
  api_url: "https://bls-api.veetal.app/api",
  analytics: {
    gaId: "G-HS3ZHZHBWK"
  }
};
